import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import calendar from 'dayjs/plugin/calendar';
import 'dayjs/locale/ru';

dayjs.extend(customParseFormat);
dayjs.extend(calendar);
dayjs.locale('ru');

const time = {
  toYear: (timestamp) => {
    return dayjs.unix(timestamp).year();
  },
  current: (format = 'DD.MM.YYYY') => {
    return dayjs().format(format);
  },
  to: (timestamp, format = 'DD.MM.YYYY') => {
    return dayjs.unix(timestamp).format(format);
  },
  toChat: (timestamp) => {
    return dayjs.unix(timestamp).calendar(null, {
      sameDay: 'HH:mm',
      lastDay: '[Вчера], HH:mm',
      sameElse: 'DD.MM.YYYY'
    });
  },

  getDay: (day, activeDate) => {
    const currDay = new Date().getDay();

    let dd = dayjs.unix(activeDate).format("YYYYMMDD");
    let ndd = dayjs(dd).startOf('day').add(6, 'hours');

    let ddStart = Number(ndd.format("X"));
    let ddEnd = ddStart + 86399;

    return {
      start: ddStart - ((currDay - day) * 86400),
      end: ddEnd - ((currDay - day) * 86400)
    };
  }
};

export default time;
